export const __updateUserCredential = (data) => (dispatch) => {
  dispatch({
    type: 'UPDATE_USER_CREDENTIAL',
    payload: data
  });
};

export const __getUserCredential = () => (dispatch) => {
  dispatch({
    type: 'GET_USER_CREDENTIAL'
  });
};
